export default {
    prompt:"What color is the section background?",
    condition:{field:"backgroundState",value:"on"},
    field:"background",
    type:"style",
    colorPicker:true,
    default:"#ffffffff"
}